(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
document.addEventListener('click', function (event) {
  if (!window.matchMedia('(min-width: 750px)').matches) return;
  const toggle = event.target.closest('.collection-filters--toolbar .filters__holder > [data-filters-toggle]');
  if (toggle) {
    event.preventDefault();
    event.stopImmediatePropagation();
    const holder = toggle.closest('.filters__holder');
    const open = holder.classList.toggle('is-desktop-filter-open');
    toggle.setAttribute('aria-expanded', String(open));
    return;
  }
  document.querySelectorAll('.collection-filters--toolbar .filters__holder.is-desktop-filter-open').forEach(function (holder) {
    if (!holder.contains(event.target)) {
      holder.classList.remove('is-desktop-filter-open');
      holder.querySelector(':scope > [data-filters-toggle]').setAttribute('aria-expanded', 'false');
    }
  });
}, true);
document.addEventListener('keydown', function (event) {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.collection-filters--toolbar .filters__holder.is-desktop-filter-open').forEach(function (holder) {
    holder.classList.remove('is-desktop-filter-open');
    const toggle = holder.querySelector(':scope > [data-filters-toggle]');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.focus();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scoff-product-ugc"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('scoff-product-ugc')) {
  customElements.define('scoff-product-ugc', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      const pool = [...this.querySelectorAll('template[data-ugc-photo]')];
      const shuffle = items => {
        const copy = [...items];
        for (let i = copy.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [copy[i], copy[j]] = [copy[j], copy[i]];
        }
        return copy;
      };
      const preferred = shuffle(pool.filter(item => this.dataset.occasion !== 'general' && item.dataset.occasion === this.dataset.occasion));
      const other = shuffle(pool.filter(item => !preferred.includes(item)));
      const selected = [...preferred, ...other].slice(0, 3);
      const grid = this.querySelector('.scoff-product-ugc__grid');
      if (!grid) return;
      selected.forEach(item => grid.append(item.content.cloneNode(true)));
      this.dataset.ready = 'true';
      const ugcSection = this.closest('.scoff-product-ugc');
      const media = document.querySelector('.product-section .product__slides');
      const mediaColumn = media && media.closest('.grid__item--product');
      if (ugcSection && mediaColumn && !mediaColumn.contains(ugcSection)) {
        mediaColumn.append(ugcSection);
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
